import { Outlet } from 'react-router-dom';
import { NotFound } from 'shell/error/components/error-not-found';
import PracticeResearchPage from 'practice/pages/research';
import PracticedetailPage from 'practice/pages/detail';
import HomePage from 'practice/pages/home';
import {
  PracticeResearchAuthorizations,
  PracticeAuthorizationsList,
  ResearchRegisterAuthorizations,
  TypePracticeAuthorizations,
  TypeOperationAuthorizations,
  ResponsibleAuthorizations,
  MetricAuthorizations,
  AssignOperatorPractice,
} from 'shell/authorizations/practice';
import PracticeAssignOperatorPage from 'practice/pages/assign-practice-operator';
import PracticesAssignOperatorPage from 'practice/pages/assign-practices-operator';
import PracticeEditPage from 'practice/pages/edit';
import ResearchRegister from 'practice/pages/register';
import NewRegister from 'practice/pages/register/new';
import DetailRegister from 'practice/pages/register/detail';
import EditRegister from 'practice/pages/register/edit';
import ResearchTypePractice from 'practice/pages/type-practice';
import NewTypePractice from 'practice/pages/type-practice/new';
import EditTypePractice from 'practice/pages/type-practice/edit';
import DetailTypePractice from 'practice/pages/type-practice/detail';
import ResearchTypeOperation from 'practice/pages/type-operation';
import NewTypeOperation from 'practice/pages/type-operation/new';
import EditTypeOperation from 'practice/pages/type-operation/edit';
import DetailTypeOperation from 'practice/pages/type-operation/detail';
import ResearchResponsible from 'practice/pages/responsible';
import NewResponsible from 'practice/pages/responsible/new';
import EditResponsible from 'practice/pages/responsible/edit';
import DetailResponsible from 'practice/pages/responsible/detail';
import ResearchMetric from 'practice/pages/metric';
import NewMetric from 'practice/pages/metric/new';
import EditMetric from 'practice/pages/metric/edit';
import DetailMetric from 'practice/pages/metric/detail';
import NewPerson from 'practice/pages/new-person';
import NewPractice from 'practice/pages/new';
import StoragePersonPage from 'practice/pages/storage-practice';
import { TypePractice } from 'practice/constants/type-practice';
import NotificationManagementList from 'practice/pages/notification-management/search';
import NotificationManagementDetail from 'practice/pages/notification-management/detail';
import PageNotificationManagement from 'practice/pages/notification-management';
import {
  PracticeDetailCrumbs,
  PracticeManagementCrumbs,
  PracticeManagementUnavailabilityCrumbs,
} from 'practice/constants/practice-crubs';

export const practiceRoutes = [
  {
    path: '',
    element: <Outlet />,
    children: [
      {
        path: '/',
        name: '',
        hidden: true,
        authorizations: PracticeAuthorizationsList,
        element: <HomePage />,
      },
      {
        path: '/ricerca',
        name: 'Ricerca Pratica',
        authorizations: PracticeResearchAuthorizations,
        element: <StoragePersonPage />,
        children: [
          {
            path: '',
            element: <PracticeResearchPage />,
          },
          {
            path: '/dettaglio/:codiceEnte/:tipoRegistro/:idAnnoPratica/:progressivoPratica/:idDbLocaleRichiedente/:idAnprIntestatario/:tipoPratica',
            element: <Outlet />,
            children: [
              {
                path: '',
                element: <PracticedetailPage isDetail />,
              },
              {
                path: '/notifiche/:id',
                element: (
                  <NotificationManagementDetail
                    goBackUrl="/pratiche/ricerca/dettaglio/:codiceEnte/:tipoRegistro/:idAnnoPratica/:progressivoPratica/:idDbLocaleRichiedente/:idAnprIntestatario/:tipoPratica"
                    breadcrumbs={[
                      ...PracticeDetailCrumbs,
                      {
                        name: 'Dettaglio Notifica',
                      },
                    ]}
                  />
                ),
              },
            ],
          },
          {
            path: '/gestione-pratica/:codiceEnte/:tipoRegistro/:idAnnoPratica/:progressivoPratica/:idDbLocaleRichiedente/:idAnprIntestatario/:tipoPratica',
            element: <Outlet />,
            children: [
              {
                path: '',
                element: <PracticedetailPage />,
              },
              {
                path: '/notifiche/:id',
                element: (
                  <NotificationManagementDetail
                    goBackUrl="/pratiche/ricerca/gestione-pratica/:codiceEnte/:tipoRegistro/:idAnnoPratica/:progressivoPratica/:idDbLocaleRichiedente/:idAnprIntestatario/:tipoPratica"
                    breadcrumbs={[
                      ...PracticeManagementCrumbs,
                      {
                        name: 'Dettaglio Notifica',
                      },
                    ]}
                  />
                ),
              },
            ],
          },
          {
            path: '/modifica/:codiceEnte/:tipoRegistro/:idAnnoPratica/:progressivoPratica/:tipoPratica',
            element: <PracticeEditPage />,
          },
          {
            path: '/modifica/anagrafe-temporanea/:codiceEnte/:tipoRegistro/:idAnnoPratica/:progressivoPratica/:tipoPratica',
            element: <PracticeEditPage ForPracticeTemporaryNew />,
          },
          {
            path: '/modifica/:codiceEnte/:tipoRegistro/:idAnnoPratica/:progressivoPratica/:tipoPratica/nuova-persona',
            element: <NewPerson />,
          },
          {
            path: '/gestione-pratica/irreperibilita/:codiceEnte/:tipoRegistro/:idAnnoPratica/:progressivoPratica/:idDbLocaleRichiedente/:idAnprIntestatario/:tipoPratica',
            element: <Outlet />,
            children: [
              {
                path: '',
                element: <PracticedetailPage isPraticeUnAvailability />,
              },
              {
                path: '/notifiche/:id',
                element: (
                  <NotificationManagementDetail
                    goBackUrl="/pratiche/ricerca/gestione-pratica/irreperibilita/:codiceEnte/:tipoRegistro/:idAnnoPratica/:progressivoPratica/:idDbLocaleRichiedente/:idAnprIntestatario/:tipoPratica"
                    breadcrumbs={[
                      ...PracticeManagementUnavailabilityCrumbs,
                      {
                        name: 'Dettaglio Notifica',
                      },
                    ]}
                  />
                ),
              },
            ],
          },
          {
            path: '/assegnazione-operatore/:codiceEnte/:tipoRegistro/:idAnnoPratica/:progressivoPratica',
            element: <PracticeAssignOperatorPage />,
            authorizations: AssignOperatorPractice,
          },
        ],
      },
      {
        path: '/notifiche',
        name: 'Notifiche',
        element: <PageNotificationManagement />,
        children: [
          {
            path: '',
            element: <NotificationManagementList />,
          },
          {
            path: '/dettaglio/:id',
            element: <NotificationManagementDetail />,
          },
        ],
      },
      {
        path: '/nuova-pratica/cambio-residenza',
        name: 'Apertura Pratica Cambio Residenza',
        element: <NewPractice tipoPratica={TypePractice.Residence} />,
      },
      {
        path: '/nuova-pratica/immigrazione',
        name: 'Apertura Pratica Immigrazione',
        element: <NewPractice tipoPratica={TypePractice.Immigration} />,
      },
      {
        path: '/nuova-pratica/emigrazione',
        name: 'Apertura Pratica Emigrazione',
        element: <NewPractice tipoPratica={TypePractice.Emigration} />,
      },
      {
        path: '/nuova-pratica/anagrafe-temporanea',
        name: 'Apertura Pratica Di Anagrafe Temporanea',
        element: (
          <NewPractice tipoPratica={TypePractice.Registerofficetemporary} ForAnagrafeTemporanea />
        ),
      },
      {
        path: '/nuova-pratica/irreperibilita',
        name: 'Apertura Pratica Irreperibilità',
        hidden: true,
        element: <NewPractice tipoPratica={TypePractice.Unavailable} />,
      },
      {
        path: '/nuova-pratica/censimento/irreperibilita',
        name: 'Apertura Pratica Irreperibilità per censimento',
        element: <NewPractice tipoPratica={TypePractice.UntraceableCensus} />,
      },
      {
        element: <StoragePersonPage />,
        path: '/assegnazione-operatore',
        name: 'Assegnazione massiva operatore',
        authorizations: AssignOperatorPractice,
        children: [
          {
            path: '',
            element: <PracticesAssignOperatorPage />,
          },
        ],
      },
      {
        path: '/ricerca-registro',
        name: 'Ricerca Registro',
        hidden: true,
        authorizations: ResearchRegisterAuthorizations,
        children: [
          {
            path: '',
            element: <ResearchRegister />,
          },
          {
            path: '/nuovo',
            element: <NewRegister />,
          },
          {
            path: '/dettaglio/:id',
            element: <DetailRegister />,
          },
          {
            path: '/modifica/:id',
            element: <EditRegister />,
          },
        ],
      },
      {
        path: '/ricerca-tipo-pratica',
        name: 'Ricerca Tipo Pratica',
        hidden: true,
        authorizations: TypePracticeAuthorizations,
        children: [
          {
            path: '',
            element: <ResearchTypePractice />,
          },
          {
            path: '/nuovo',
            element: <NewTypePractice />,
          },
          {
            path: '/modifica/:id',
            element: <EditTypePractice />,
          },
          {
            path: '/dettaglio/:id',
            element: <DetailTypePractice />,
          },
        ],
      },
      {
        path: '/ricerca-tipo-operazione',
        name: 'Ricerca Tipo Operazione',
        hidden: true,
        authorizations: TypeOperationAuthorizations,
        children: [
          {
            path: '',
            element: <ResearchTypeOperation />,
          },
          {
            path: '/nuovo',
            element: <NewTypeOperation />,
          },
          {
            path: '/modifica/:tyPratica/:tyOperazione',
            element: <EditTypeOperation />,
          },
          {
            path: '/dettaglio/:tyPratica/:tyOperazione',
            element: <DetailTypeOperation />,
          },
        ],
      },
      {
        path: '/ricerca-responsabile',
        name: 'Ricerca Responsabile',
        hidden: true,
        authorizations: ResponsibleAuthorizations,
        children: [
          {
            path: '',
            element: <ResearchResponsible />,
          },
          {
            path: '/nuovo',
            element: <NewResponsible />,
          },
          {
            path: '/modifica/:tyPratica/:codServizio/',
            element: <EditResponsible />,
          },
          {
            path: '/dettaglio/:tyPratica/:codServizio/',
            element: <DetailResponsible />,
          },
        ],
      },
      {
        path: '/ricerca-metrica',
        name: 'Ricerca Metrica',
        hidden: true,
        authorizations: MetricAuthorizations,
        children: [
          {
            path: '',
            element: <ResearchMetric />,
          },
          {
            path: '/nuovo',
            element: <NewMetric />,
          },
          {
            path: '/modifica/:tyRegistro/:tyPratica/:tyOperazione/:codStatoPratica/:dataAttivazione',
            element: <EditMetric />,
          },
          {
            path: '/dettaglio/:tyRegistro/:tyPratica/:tyOperazione/:codStatoPratica/:dataAttivazione',
            element: <DetailMetric />,
          },
        ],
      },
      {
        element: <NotFound />,
        path: '*',
        hidden: true,
      },
    ],
  },
];
